export default "__VITE_ASSET__B05ZKhSO__"